export default function itemTrim(item){
    if(item === null || item === undefined){
        return item
    }else if(typeof item === "number" || typeof item === "boolean"){
        return item
    }else if(typeof item === "string"){
        return item.trim()
    }else if(typeof item === "object"){
        if(typeof item.length === "number"){
            item.forEach((e,index) => {
                item[index] = itemTrim(e);
            })
            return item
        }else{
            let tempObject = {...item};
            Object.getOwnPropertyNames(tempObject).forEach(e => {
                item[e] = itemTrim(item[e]);
            })
            return item
        }
    }
}